import styled from 'styled-components';
import BaseEllipsesMenuIcon from '#/shared/components/GeneratedIcons/generic/EllipsesMenu';
import { focusCssRule } from '#/shared/css/focus';

export const EllipsesButtonGroup = styled.div`
  position: relative;
`;
export const EllipsesButton = styled.button`
  background-color: transparent;
  border: none;
  display: flex;
`;

export const EllipsesMenuIcon = styled(BaseEllipsesMenuIcon).attrs(props => ({
  fill: props.theme.popoverMLEllipsesFill,
  height: 30,
  width: 30,
}))`
  cursor: pointer;
  opacity: 1;
  &:hover {
    opacity: ${props => props.theme.hoverOpacity};
  }
  & circle {
    transform: translateX(3.25rem);
  }
`;

export const PopOverMenuList = styled.ul`
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  list-style: none;
  border-radius: ${props => props.theme.buttonRadius};
  overflow: hidden;
  background-color: ${props => props.theme.popoverMLBg};
`;

export const PopOver = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  right: 50px;
`;

export const PopoverMenuListItem = styled.li`
  display: flex;
  flex: 1 0 auto;
  position: relative;
  & a,
  & button {
    font-size: 1rem;
    display: flex;
    flex: 1 0 auto;
    align-items: center;
    padding: 0.5em 0.75em;
    color: ${props => props.theme.popoverMLText};
    background-color: transparent;
    text-align: left;
    text-decoration: none;
    border: none;
    cursor: pointer;
    &:hover,
    &:focus,
    &:focus-visible {
      background-color: ${props => props.theme.popoverMLItemHover};
    }

    ${focusCssRule({ type: 'inset' })}
  }
  &:not(:last-child)::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 5%;
    border-bottom: 2px solid ${props => props.theme.popoverMLBorder};
    width: 90%;
    z-index: -1;
  }
`;
